import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
  site: SiteModel
}
const ContractDescriptionCell: FC<Props> = ({ site }) => (

  <div className='d-flex align-items-center'>
    {site.contractDescription} ({site.sequence})
  </div>

)
export { ContractDescriptionCell }
